import React from "react";
import {
  BuilderFieldButton,
  BuilderFieldCategoryName,
} from "../../../SubmissionsBuilder/__styles__/SubmissionsBuilder";
import { MODULES } from "../../constants";
import { useBuilderWatch } from "../../form";
import { BuilderFieldListItem, BuilderFieldsList } from "./__styles__/shared";

export function ModulesList() {
  const selectedModules = useBuilderWatch("modules");

  const addableModules = MODULES.filter(
    ({ type }) => !selectedModules.includes(type),
  );

  if (!addableModules.length) {
    return null;
  }

  return (
    <div>
      <BuilderFieldCategoryName>Modules</BuilderFieldCategoryName>
      <BuilderFieldsList>
        {addableModules.map(({ label }) => (
          <BuilderFieldListItem key={label}>
            <BuilderFieldButton
              styleVariant="ghost"
              leftIconName="component"
              aria-label={`Add ${label} Module`}
            >
              {label}
            </BuilderFieldButton>
          </BuilderFieldListItem>
        ))}
      </BuilderFieldsList>
    </div>
  );
}
